import { GroupVisitControllerApi } from "@/services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "@/utils/utils";

type Params = {
  groupVisitId: string;
  /** False keeps the patient booked in sessions already scheduled. */
  cancelUpcomingSessions: boolean;
  patientId: string;
};

/**
 * Removes one patient from a group.
 *
 * @author Rajkumar Rathod
 */
export const useRemoveGroupVisitPatient = () =>
  useMutationWithLoading(
    async ({ groupVisitId, patientId, cancelUpcomingSessions }: Params) =>
      new GroupVisitControllerApi(
        getConfigObject()
      ).removePatientFromGroupVisit(
        groupVisitId,
        patientId,
        cancelUpcomingSessions,
        getXtenantId()
      )
  );
